import tutor_img from "../../../Assets/Tutor/tutor_image.png";
import "./UniversityPaymentSuccess.scss";
import { Container } from "@mui/material";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../Constants/Constants";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import MobileCalenderIcon from "../../../Assets/Tutor/tutorPaymentCalIcon.svg";
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import { nullUndefinedEmptyCheck } from "../../../Utilities/Helpers/Helper";
import moment from 'moment';
import conslutingImg from "../../../Assets/University/conslutingImg.svg";
import MySVGComponent from "../../../Assets/Asserts-Common/MySVGComponent";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";


const UniversityPaymentSuccess = () => {
    const route = useLocation();
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [CourseOpen, setCourseOpen] = useState(true);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    
    const isDateArray = (arr: any) => {
        if (arr.length <= 1) {
            return true;
        }

        for (let i = 1; i < arr.length; i++) {
            const currentDate: any = new Date(arr[i]);
            const previousDate: any = new Date(arr[i - 1]);

            
            if (currentDate - previousDate !== 24 * 60 * 60 * 1000) {
                return false; 
            }

            
            if (currentDate <= previousDate) {
                return false; 
            }
        }
        return true; 
    }

    function formatDatesWithSpaces(dateArray: any) {
        const formattedDates = dateArray.map((dateStr: any) => {
            const [year, month, day] = dateStr.split('-');
            return `${day}/${month}/${year}`;
        });

        return formattedDates.join(', ');
    }

    const handleNavigate = () => {
        
        const icsFileUrl = route?.state?.calender_link[0];

        
        const anchor = document.createElement('a');
        anchor.href = icsFileUrl;
        anchor.download = '(L & P)Calender.ics';

        
        anchor.click();
        handleClose();
        navigate(ROUTES.TUTORS)
    }

    return (
        <React.Fragment>
            <Container component="main" maxWidth="md" sx={{ mb: 4 }}>
                <div className="Universitysuccess-container">
                    <div className="paymentsuccessful__layout">
                        <div className="paymentsuccessful-left">
                            <div className="alignment3">
                                <span className="img-tick" ><MySVGComponent checkmarkStrokeColor="#12CC92" /></span>
                                <label htmlFor="" className="payment-text">Payment Successful!</label>
                            </div>
                        </div>
                        <div className="paymentsuccessfull-right">
                            <div className="topContant">
                                <div className="consluting__wapper">
                                    <img src={conslutingImg} alt="" className="consluting_Img" />
                                    <div className="left__contant">Consulting Services</div>
                                </div>
                                <div className="right__contant">AED {route?.state?.PaymentTotal}</div>
                            </div>
                            <div className="course__wapper">
                                <div className="course-detail-show">
                                    <div className="title">Booking Details</div>
                                    <KeyboardArrowDownIcon
                                        className={CourseOpen ? "Icon" : "IconInActive"}
                                        onClick={() => setCourseOpen(!CourseOpen)}
                                    />
                                </div>
                                {CourseOpen && (  
                                 <> 
                                {route?.state?.orderDetailes?.slice(0, 2)?.map((data: any) => {
                                    return (
                                        <>
                                            <div className="course__Name">{data?.title}</div>
                                            {isDateArray(data?.dates) ? (

                                                <div className="Sessions">Sessions: {data?.dates?.length} (Date  From: {moment(data?.dates[0]).format("DD/MM/YYYY")} - To: {moment(data?.dates[data?.dates?.length - 1]).format("DD/MM/YYYY")})</div>
                                            ) : (
                                                <div className="Sessions">Sessions: {data?.dates?.length} (Date  {formatDatesWithSpaces(data?.dates)})</div>
                                            )}
                                        </>
                                    )
                                })}
                                </>
                                )}

                                <div className="profile__wapper">
                                    <img src={nullUndefinedEmptyCheck(route?.state?.ProfileData?.profile_image) ? route?.state?.ProfileData?.profile_image : tutor_img} alt="" />
                                    <div className="profile__name">{route?.state?.ProfileData?.profile_details?.firstname} {" "} {route?.state?.ProfileData?.profile_details?.lastname}</div>
                                </div>
                            </div>
                            <div className="transaction-container">
                                <label className="td-text">Transaction Details</label>
                                <div className="transaction-deatiles__wapper">
                                    <div className="ti-container">
                                        <label>Transaction ID</label>
                                        <span>485983593829238</span>
                                    </div>
                                    <div className="t12-container">
                                        <label>Date & Time</label>
                                        <span>{moment().format("MMMM Do, YYYY h:mm a")}</span>
                                    </div>
                                </div>
                                <div className="display-css">
                                    <button className="btn-share">
                                        <ShareOutlinedIcon className="share__icon" />
                                        <span>Share Receipt</span>
                                    </button>
                                    <button className="btn-done" onClick={() => handleClickOpen()}>Done</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {open && (
                    <div className="overlay-ModelBackround">
                        <Dialog open={open} onClose={handleClose}>
                            <DialogTitle>
                                <IconButton
                                    edge="end"
                                    color="inherit"
                                    onClick={handleClose}
                                    aria-label="close"
                                    sx={{
                                        position: 'absolute',
                                        top: 6,
                                        right: 13,
                                    }}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </DialogTitle>
                            <DialogContent>
                                <div className="University__Payment__Success__Pop">
                                    <div className="Payment__Pop__wapper">
                                        <img src={MobileCalenderIcon} alt="" />
                                        <div className="text">Add booking to your calendar?</div>
                                    </div>
                                    <div className="Payment__bottom__btn">
                                        <button className="backBtn" onClick={handleClose}>Cancel</button>
                                        <button className="SuccessBtn" onClick={() => handleNavigate()}>Okay</button>
                                    </div>
                                </div>
                            </DialogContent>
                        </Dialog>
                    </div>
                )}
            </Container>
        </React.Fragment>
    )
}

export default UniversityPaymentSuccess;